export const MuiInputLabel = {
  styleOverrides: {
    root: {
      color: '#000000',
      opacity: 0.6,
    },
  },
};
